import React from 'react';
import PropTypes from 'prop-types';
import { Label } from '../../ui/label';

export function ProcessorStep5Insights({ formData, handleInputChange }) {
  return (
    <div className="space-y-6">
      <h3 className="text-xl font-semibold text-red-900 border-b-2 border-red-200 pb-2">
        Business Insights & Plans
      </h3>
      <div className="space-y-4">
        <div>
          <Label htmlFor="whatInterestYouToGoOnCacaoProcessing">What interested you in cacao processing?</Label>
          <textarea
            id="whatInterestYouToGoOnCacaoProcessing"
            value={formData.whatInterestYouToGoOnCacaoProcessing}
            onChange={(e) => handleInputChange('whatInterestYouToGoOnCacaoProcessing', e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.stopPropagation();
              }
            }}
            placeholder="Share your motivation and interest in cacao processing..."
            className="w-full p-3 border border-gray-300 rounded-md h-24 resize-none"
          />
        </div>
        <div>
          <Label htmlFor="challengesEncounteredInProcessing">What challenges have you encountered in processing?</Label>
          <textarea
            id="challengesEncounteredInProcessing"
            value={formData.challengesEncounteredInProcessing}
            onChange={(e) => handleInputChange('challengesEncounteredInProcessing', e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.stopPropagation();
              }
            }}
            placeholder="Describe the main challenges you face in your processing business..."
            className="w-full p-3 border border-gray-300 rounded-md h-24 resize-none"
          />
        </div>
        <div>
          <Label htmlFor="supportsNeededToImprove">What support do you need to improve your business?</Label>
          <textarea
            id="supportsNeededToImprove"
            value={formData.supportsNeededToImprove}
            onChange={(e) => handleInputChange('supportsNeededToImprove', e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.stopPropagation();
              }
            }}
            placeholder="What kind of support, training, or resources would help improve your business..."
            className="w-full p-3 border border-gray-300 rounded-md h-24 resize-none"
          />
        </div>
        <div>
          <Label htmlFor="futurePlans">What are your future plans?</Label>
          <textarea
            id="futurePlans"
            value={formData.futurePlans}
            onChange={(e) => handleInputChange('futurePlans', e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.stopPropagation();
              }
            }}
            placeholder="Share your vision and plans for the future of your business..."
            className="w-full p-3 border border-gray-300 rounded-md h-24 resize-none"
          />
        </div>
      </div>
    </div>
  );
}

ProcessorStep5Insights.propTypes = {
  formData: PropTypes.object.isRequired,
  handleInputChange: PropTypes.func.isRequired,
};
